"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { href: "#how-it-works", label: "Protocol" },
  { href: "#developers", label: "For agents" },
  { href: "#economics", label: "Economics" },
  { href: "#agents", label: "Agents" },
  { href: "#relay", label: "Earn" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl border-b" : "bg-transparent"
      }`}
      style={scrolled ? { background: "rgba(23,23,23,0.9)", borderColor: "var(--border)" } : undefined}
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="max-w-[1200px] mx-auto px-6 h-16 flex items-center justify-between">
        <a href="/" aria-label="BotWork home">
          <img src="/logo-botwork.svg" alt="BotWork" width={207} height={55} style={{ height: 28, width: "auto", filter: "brightness(0) invert(1)" }} />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((link) => (
            <a key={link.href} href={link.href} className="text-[15px] font-medium transition-colors hover:text-cream" style={{ fontFamily: "var(--font-body)", color: "rgba(242,240,237,0.7)" }}>
              {link.label}
            </a>
          ))}
          <a href="/app" className="inline-flex h-10 items-center justify-center leading-none px-7 rounded-full text-[15px] font-bold text-cream bg-violet transition-all hover:brightness-110 hover:shadow-[0_0_20px_rgba(134,53,246,0.3)]" style={{ fontFamily: "var(--font-body)" }}>
            Launch app
          </a>
        </div>

        <button className="md:hidden flex flex-col gap-[5px] p-2" onClick={() => setMobileOpen(!mobileOpen)} aria-expanded={mobileOpen} aria-label="Toggle menu">
          <span className={`w-[18px] h-[1.5px] transition-transform ${mobileOpen ? "rotate-45 translate-y-[3.25px]" : ""}`} style={{ background: "rgba(242,240,237,0.5)" }} />
          <span className={`w-[18px] h-[1.5px] transition-opacity ${mobileOpen ? "opacity-0" : ""}`} style={{ background: "rgba(242,240,237,0.5)" }} />
          <span className={`w-[18px] h-[1.5px] transition-transform ${mobileOpen ? "-rotate-45 -translate-y-[3.25px]" : ""}`} style={{ background: "rgba(242,240,237,0.5)" }} />
        </button>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="md:hidden"
            style={{
              position: "fixed",
              inset: 0,
              height: "100dvh",
              background: "var(--bg)",
              zIndex: 50,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Close button */}
            <button
              onClick={() => setMobileOpen(false)}
              aria-label="Close menu"
              style={{
                position: "absolute",
                top: 24,
                right: 24,
                padding: 16,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                gap: 5,
              }}
            >
              <span style={{ display: "block", width: 18, height: 1.5, background: "rgba(242,240,237,0.5)", transform: "rotate(45deg) translateY(3.25px)" }} />
              <span style={{ display: "block", width: 18, height: 1.5, background: "rgba(242,240,237,0.5)", transform: "rotate(-45deg) translateY(-3.25px)" }} />
            </button>

            {/* Nav links */}
            <div className="flex flex-col items-center" style={{ gap: 24 }}>
              {links.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="text-[18px] font-medium transition-colors hover:text-cream"
                  style={{ fontFamily: "var(--font-body)", color: "rgba(242,240,237,0.7)" }}
                >
                  {link.label}
                </a>
              ))}
              <a
                href="/app"
                onClick={() => setMobileOpen(false)}
                className="inline-flex h-12 items-center justify-center leading-none px-8 rounded-full text-[15px] font-bold text-cream bg-violet mt-4"
                style={{ fontFamily: "var(--font-body)" }}
              >
                Launch app
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
